import { initialState, sliceKey } from './slice';

const selectAuthState = (state) => state[sliceKey] ?? initialState;

export { selectAuthState };
